import { Project } from 'app/services/sites/types';
import { Unit } from 'app/services/units/types';
import { User } from 'app/services/users/types';

// The API builds the message in the language of the site's country; only the signature is added here.
export const buildProjectEmail = (project: Project, signature: string): string =>
  `<hbr/>${project.Message.replace(/\n/g, '<br/>')}<br/><br/>${signature}`;

export const buildSenderSignature = (user: User, footer: string): string => {
  const sender = [ user.FirstLastName, user.JobTitle, user.PhoneNumber, user.Email ].filter(Boolean).join('<br/>');
  return `${sender}<br/><br/>${footer}`;
};

export const buildSignature = (unit: Unit): string => {
  const address = unit.AddressText ? `${unit.AddressText}<br/><br/>` : '';
  return `${unit.Name}<br/><br/>${address}`;
};